export default "__VITE_ASSET__nX_zK4mP__"